import styles from './PaymentSuccess.module.css'
export default function PaymentSuccess()
{
    return(
        <div className={styles.mainCont}>
            <span>Платеж прошел успешно, средства зачисляться в течении 30 минут</span>
            <></>
        </div>
    )
}